import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { PageIntro, useTranslatedList } from './shared';

/** Review fix F11: the actual terms -- $9.99/month Premium, first five levels of every path free,
 * and the real depth Premium unlocks today (counted from the seed catalog). The family plan is
 * described as planned, never sold as available. */
export function Pricing() {
  const { t } = useTranslation();
  const freeItems = useTranslatedList<string>('public.pricing.free.items');
  const premiumItems = useTranslatedList<string>('public.pricing.premium.items');
  const depthItems = useTranslatedList<string>('public.pricing.depth.items');
  const billingItems = useTranslatedList<string>('public.pricing.billing.items');

  return (
    <div className="pricing-page">
      <PageIntro title={t('public.pricing.title')} lead={t('public.pricing.lead')} />

      <div className="plan-grid">
        <section className="plan-card" aria-labelledby="plan-free">
          <h2 id="plan-free" className="plan-name">{t('public.pricing.free.name')}</h2>
          <p className="plan-price">{t('public.pricing.free.price')}</p>
          <ul>
            {freeItems.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
          <Link to="/signup" className="btn btn-secondary btn-block">{t('public.pricing.free.cta')}</Link>
        </section>
        <section className="plan-card featured" aria-labelledby="plan-premium">
          <h2 id="plan-premium" className="plan-name">{t('public.pricing.premium.name')}</h2>
          <p className="plan-price">
            {t('public.pricing.premium.price')} <span>{t('public.pricing.premium.period')}</span>
          </p>
          <ul>
            {premiumItems.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
          <p className="plan-footnote">{t('public.pricing.premium.upgradeNote')}</p>
        </section>
      </div>

      <div className="prose">
        <section className="prose-section" aria-labelledby="pricing-depth">
          <h2 id="pricing-depth">{t('public.pricing.depth.heading')}</h2>
          <p>{t('public.pricing.depth.body')}</p>
          <ul>
            {depthItems.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
          <p>{t('public.pricing.depth.note')}</p>
        </section>
        <section className="prose-section" aria-labelledby="pricing-billing">
          <h2 id="pricing-billing">{t('public.pricing.billing.heading')}</h2>
          <ul>
            {billingItems.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </section>
        <section className="prose-section" aria-labelledby="pricing-family">
          <h2 id="pricing-family">{t('public.pricing.family.heading')}</h2>
          <p>{t('public.pricing.family.body')}</p>
        </section>
        <p className="landing-more">
          <Link to="/support" className="text-link">{t('public.pricing.questions')}</Link>
        </p>
      </div>
    </div>
  );
}
